import { inject, Injectable, Signal } from '@angular/core';

import { createFeatureSelector, createSelector, Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { AuthState } from './auth.reducer';
import { KrosUser } from '../services/auth/kros-user.model';

const selectAuthFeature = createFeatureSelector<AuthState>('auth');

const selectCurrentUser = createSelector(
  selectAuthFeature,
  state => state.currentUser
);

const selectIsLoggedIn = createSelector(
  selectAuthFeature,
  state => state.currentUser != null
);

export const fromAuth = {
  selectCurrentUser,
};

@Injectable()
export class AuthSelectorsService {
  readonly #store = inject(Store);

  readonly isLoggedIn: Signal<boolean> = this.#store.selectSignal(selectIsLoggedIn);

  readonly currentUser: Signal<KrosUser | null> = this.#store.selectSignal(selectCurrentUser);

  get currentUser$(): Observable<KrosUser | null> {
    return this.#store.select(selectCurrentUser);
  }

  /**
   * Boolean flag indicating user is logged in
   */
  get isLoggedIn$(): Observable<boolean> {
    return this.#store.select(selectIsLoggedIn);
  }
}
